// extracted by mini-css-extract-plugin
export default {"root":"Events_root__Vj4B8"};